// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3IVik","text":"SelectPayment_text__47EPj","title":"SelectPayment_title__2_gXU","btn":"SelectPayment_btn__1cvls"};